<template>
	<div id="container">
		<div class="reg_page">
			<Reg></Reg>
		</div>
	</div>
</template>

<script>
	import Login from '../../components/login/login.vue'
  import Logout from '../../components/login/logout.vue'
  import Reg from '../../components/reg/reg.vue'
  import { mapState } from 'vuex'


  export default {
		data() {
			return {
			  isLogin:false
			}
		},
    components:{
      Login,
      Logout,
      Reg
    },
    computed: mapState([
      'loginPage'
    ])
	}
</script>

<style lang="scss" scoped>
	@import '../../components/style/mixin';
	#container{margin-bottom: 60px;margin-top: -5px}
	.border_blue{border-bottom: 3px solid #1990FF;padding-bottom: 5px}
	.banner{background: url("../../images/middle_bg.png") no-repeat top 0 left 0 /100% 100%;height: 512px;padding-top: 75px;padding-right: 11%}
	.game_title{color: #333333;text-align: center;font-size: 42px;margin-top: 30px;margin-bottom: 30px;line-height: 50px;height: 50px;}
	.games{display: flex;justify-content: center;text-align: center}
	.games>div{width: 460px}
	.games_title{color: #333333;font-size: 24px;margin-bottom: 8px;margin-top: 5px}
	.games_inner{width: 360px;margin: 0 auto;color: #666666;text-align: left;}
	.games_img{width: 355px;height: 237px;cursor: pointer}
	.reg_page{background-color: rgb(254,254,254)}
</style>
